/* Zappycards homepage behaviour.

   The design prototype ran on a React/Babel runtime the handoff says not to port, so this
   is the same behaviour rewritten as plain vanilla JS, driven by data- attributes.

   From the prototype's `class Component`:
     - 3 hero slides, autoplaying every 6000ms
     - a dot click stops the autoplay PERMANENTLY (`this._stopped = true`), not just until
       the next tick
     - autoplay never starts under prefers-reduced-motion
     - the FAQ opens one item at a time and clicking the open one closes it (faqOpen = -1)

   The <h1> is server-rendered with slide 1's headline so a crawler never sees a rotating
   or empty H1 — only its text is swapped here. */

(function () {
  'use strict';

  /* ---------------- hero carousel ---------------- */
  function initHero(root) {
    var slides;
    try {
      slides = JSON.parse(root.getAttribute('data-slides') || '[]');
    } catch (e) {
      return;
    }
    if (slides.length < 2) return;

    var eyebrow = root.querySelector('[data-hero-eyebrow]');
    var title = root.querySelector('[data-hero-title]');
    var sub = root.querySelector('[data-hero-sub]');
    var img = root.querySelector('[data-hero-img]');
    var frame = root.querySelector('[data-hero-frame]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));

    var i = 0;
    var timer = null;
    var stopped = false;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function render() {
      var s = slides[i];
      if (eyebrow) eyebrow.textContent = s.eyebrow;
      if (title) title.textContent = s.title;
      if (sub) sub.textContent = s.sub;
      if (img && s.img) {
        img.src = s.img;
        img.alt = s.alt || '';
      }
      if (frame && s.bg) frame.style.background = s.bg;
      dots.forEach(function (d, n) {
        var on = n === i;
        d.setAttribute('aria-current', String(on));
        /* the design colours the active dot #101010 and the rest #C9C9C4 */
        d.style.background = on ? '#101010' : '#C9C9C4';
      });
    }

    function start() {
      if (reduced || stopped) return;
      clearInterval(timer);
      timer = setInterval(function () {
        i = (i + 1) % slides.length;
        render();
      }, 6000);
    }

    dots.forEach(function (d, n) {
      function pick() {
        stopped = true;               /* permanent, matching the prototype */
        clearInterval(timer);
        i = n;
        render();
      }
      d.addEventListener('click', pick);
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          pick();
        }
      });
    });

    /* Pause while the tab is hidden — a background timer that keeps swapping the LCP
       image wastes work the user cannot see. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearInterval(timer);
      else start();
    });

    render();
    start();
  }

  /* ---------------- FAQ accordion ---------------- */
  function initFaq(root) {
    var qs = Array.prototype.slice.call(root.querySelectorAll('[data-faq-q]'));
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = true;
          var sign = other.querySelector('[data-faq-sign]');
          if (sign) sign.textContent = '+';
        });
        if (!open) {
          q.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(q.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
          var sign = q.querySelector('[data-faq-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });
  }

  document.querySelectorAll('[data-hero-carousel]').forEach(initHero);
  document.querySelectorAll('[data-faq]').forEach(initFaq);
})();
